import { Link } from "react-router-dom";
import { PageShell } from "@/components/PageShell";
import { COMPANY } from "@/data/site";

export default function About() {
  return (
    <PageShell>
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 md:pt-28 pb-16">
        <p className="overline">Our story</p>
        <div className="grid md:grid-cols-12 gap-10 mt-6">
          <div className="md:col-span-6">
            <h1 className="font-serif text-6xl md:text-7xl leading-[0.95] tracking-tighter">
              The <span className="italic text-[#C27A62]">KS Infinity</span> origin.
            </h1>
          </div>
          <div className="md:col-span-6 md:pt-8">
            <p className="text-lg text-[#5C665C] leading-relaxed">
              Launched by <strong className="text-[#1C2C22]">Ansh</strong> as a
              fresh manufacturing startup built for India's evolving green
              economy, KS Infinity Export is a proud sister company of the
              established <strong className="text-[#1C2C22]">KS Group</strong>.
            </p>
            <p className="mt-6 text-lg text-[#5C665C] leading-relaxed">
              We engineer zero-plastic, certified compostable paper packaging
              that handles the heavy lifting of daily retail and hospitality
              operations without breaking a sweat.
            </p>
            <p className="mt-6 text-lg text-[#5C665C] leading-relaxed">
              We provide the commercial durability your business demands, with
              the <span className="italic text-[#C27A62]">zero-waste footprint</span>{" "}
              your customers expect.
            </p>
          </div>
        </div>
      </section>

      <section className="relative">
        <div className="max-w-[1600px] mx-auto px-4">
          <div className="zoom-wrap border border-[#D1C9B8]">
            <img
              src="https://images.unsplash.com/photo-1655122878062-a9e885391a1b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxwYXBlciUyMGZhY3RvcnklMjBtYW51ZmFjdHVyaW5nfGVufDB8fHx8MTc4Mjc2MDEwNnww&ixlib=rb-4.1.0&q=85"
              alt="Paper manufacturing facility"
              className="w-full max-h-[65vh] object-cover"
            />
          </div>
        </div>
      </section>

      <section
        data-testid="about-values"
        className="max-w-7xl mx-auto px-6 lg:px-10 py-24 md:py-32 grid md:grid-cols-12 gap-10"
      >
        <div className="md:col-span-4">
          <p className="overline">What we stand for</p>
          <h2 className="font-serif text-5xl md:text-6xl mt-4 tracking-tight">
            Rooted in craft,<br />
            <span className="italic text-[#C27A62]">grown for the world.</span>
          </h2>
        </div>
        <div className="md:col-span-8 grid sm:grid-cols-2 gap-x-10 gap-y-12">
          {[
            {
              t: "Sustainability first",
              d: "Every SKU is compostable and made from responsibly sourced pulp. No hidden plastics, no laminated shortcuts.",
            },
            {
              t: "Made-in-India excellence",
              d: "In-house production means we own quality, timelines and pricing — end to end.",
            },
            {
              t: "Custom by default",
              d: "Sizes, GSMs, prints, handles — configurable per client, not a rigid catalog.",
            },
            {
              t: "People-run",
              d: "Founders on every call. No layers between you and the factory floor.",
            },
          ].map((v) => (
            <div key={v.t} className="border-t border-[#D1C9B8] pt-6">
              <h3 className="font-serif text-2xl tracking-tight">{v.t}</h3>
              <p className="mt-3 text-[#5C665C]">{v.d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24">
        <div className="bg-[#1C2C22] text-[#F4F1EB] p-10 md:p-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <div>
            <p className="overline text-[#8A9A86]">Meet the founders</p>
            <h3 className="font-serif text-4xl md:text-5xl mt-3">
              Speak with {COMPANY.contacts[0].name} or {COMPANY.contacts[1].name} directly.
            </h3>
          </div>
          <Link
            to="/contact"
            data-testid="about-cta-contact"
            className="inline-flex items-center gap-3 border border-[#F4F1EB]/60 px-6 py-4 text-xs uppercase tracking-[0.25em] btn-lift hover:bg-[#F4F1EB] hover:text-[#1C2C22]"
          >
            Start a conversation →
          </Link>
        </div>
      </section>
    </PageShell>
  );
}
